export const messages = {
  '0': 'פעולה בוצעה בהצלחה',
  '-1': 'פעולה נכשלה, נסו שנית או פנו לתמיכה',
  '-2': 'קובץ 6101 סגירה לא נוצר, אנא בידקו את תקינות כלל הנתונים ונסו שוב או פנו לתמיכה',
  '-3': 'אין מספיק מידע לבצע את הפעולה, אנא בדקו שנית או פנו לתמיכה',
  '-4': 'אירעה שגיאה בשליחה לריווחית',
  '-5': 'הנתונים נשמרו אך הייתה בעיה בעדכון רווחית',
  UPLOADING_FILE: "מעלה נתונים, אנא המתינו",
  REQUEST_ENDED_SUCCESSFULLY: "בקשה הסתיימה בהצלחה",
  OPERATION_COMPLETED: 'פעולה בוצעה בהצלחה',
  OPERATION_FAILED: 'פעולה נכשלה, נסו שנית או פנו לתמיכה',
  EDIT_FAILED: 'עריכה נכשלה',
  INVOICE_CANCEL_SUCCESS: 'ביטול החשבונית הצליח',
  INVOICE_CANCEL_ERROR: 'ביטול החשבונית נכשל',
  INVOICE_ORDERS_SENDING_SUCCESS: 'כל הבקשות הסתיימו בהצלחה',
  INVOICE_ORDERS_SENDING_FAIL_ALL: 'כל הבקשות נכשלו',
  INVOICE_ORDERS_SENDING_FAIL_SOME: 'חלק מהבקשות הסתיימו בהחה וחלק נכשלו, יש לרפרש את העמוד ולראות מידע מפורט לכל בקשה',
};
